import React from 'react';
import Relay from 'react-relay';
import { Route, withRouter } from 'react-router';
import TimeoutDialog from '../../../components/modal/timeout';
import Product from '../../../components/product';
import questionnaire from '../../../components/questionnaire';
import consult from '../../consult';
import { CompleteMutation } from '../mutation';
import dashboard from './dashboard';
import Loading from './loading';

export default ({ path, actionPipe, scenario, meta, Dashboard = dashboard }) => {
  const Questionnaire = questionnaire(scenario, path, actionPipe);
  const Purchase = (props) => (
    <Product
      questionnaire={Questionnaire}
      dashboard={Dashboard}
      path={path}
      actionPipe={actionPipe}
      meta={meta}
      {...props}
    />
  );

  const messages = ((scenario) => {
    switch (scenario) {
      case 'Affordability':
        return [
          <h2 key="msg-a">
            Processing your <strong>information</strong>.
          </h2>,
          <h2 key="msg-b">
            <strong>Analyzing</strong> what you can afford.
          </h2>,
          <h2 key="msg-c">
            Matching you with a <strong>licensed advisor</strong>.
          </h2>
        ];
      default:
        return null;
    }
  })(scenario);

  const LoadingDialog = (props) => (
    <Loading actionPipe={actionPipe} path={path} {...props} messages={messages} />
  );

  return (
    <Route
      path={path}
      queries={{
        viewer: () => Relay.QL`query { viewer }`
      }}
      component={Relay.createContainer(withRouter(Purchase), {
        fragments: {
          viewer: () => Relay.QL`
               fragment on Viewer {
                 id
                 advisor
                 consultPath
                 products {
                   apr
                   rate
                   loanTerm
                   amortizationType
                 }
                 ${Questionnaire.getFragment('viewer')}
                 activeLoan {
                   creditAgree
                   acceptedOffer
                   propertyType
                   occupancy
                   purchasePrice
                   downPayment
                   advisor
                   purchaseTimeFrame
                   refiPurpose
                   cashOutValue
                 }
                 primaryBorrower {
                   email
                 }
               }
             `
        }
      })}
    >
      {consult}
      <Route path="error" component={withRouter(TimeoutDialog(path))} />
      <Route
        path="complete"
        queries={{
          viewer: () => Relay.QL`query { viewer }`
        }}
        component={Relay.createContainer(withRouter(LoadingDialog), {
          fragments: {
            viewer: () => Relay.QL`
              fragment on Viewer {
                consultPath
                advisor
                products {
                  apr
                  rate
                  loanTerm
                  amortizationType
                }
                activeLoan {
                  acceptedOffer
                }
                ${CompleteMutation.getFragment('viewer')}
              }
            `
          }
        })}
      />
    </Route>
  );
};



// WEBPACK FOOTER //
// ./src/products/shared/qualify/page.js